import {
  AUTOMATION_TRIGGER_COMBINATION,
  AUTOMATION_TRIGGER_DATA_FIELD_TYPE,
} from '../../MedicareProAPI/Entities/Automation/Automation';
import { AUTOMATION_ACTION_TYPE } from '../../MedicareProAPI/Entities/Automation/AutomationAction';
import { IndGender } from '../../MedicareProAPI/Entities/Ind/Ind';
import { IndStatus } from '../../MedicareProAPI/Entities/Ind/Ind';
import {
  INDIVIDUAL_POLICY_STATUS_TYPE,
  INDIVIDUAL_POLICY_WRITTEN_AS,
} from '../../MedicareProAPI/Entities/Ind/IndPolicy';
import { PLAN_TYPE_TYPE } from '../../MedicareProAPI/Entities/Plan';
import { USER_ACTIVITY_PRIORITY_TYPE } from '../../MedicareProAPI/Entities/User/UserActivity';
import { USER_LETTER_TYPE_TYPE } from '../../MedicareProAPI/Entities/User/UserLetter';
import { Language } from '../../MedicareProAPI/Utilities/Languages';
import { DIRECTMAILMANAGER_POSTCARD_SIZE } from '../Components/Form/Field/DirectMailManagerTemplate';
import {
  THANKSIO_MAIL_TYPE,
  THANKSIO_POSTCARD_SIZE,
} from '../Components/Form/Field/ThanksIOTemplate';
import { PROFILE_LOG_TAB } from '../Panels/ProfileNotesLogsPanel';
import type { SelectMap } from '../Utilities/SelectMap';

export const LANGUAGE_LABELS: SelectMap[] = [
  {
    value: Language.English,
    label: 'English',
  },
  {
    value: Language.Spanish,
    label: 'Spanish',
  },
  {
    value: Language.French,
    label: 'French',
  },
  {
    value: Language.Portuguese,
    label: 'Portuguese',
  },
  {
    value: Language.Chinese,
    label: 'Chinese',
  },
  {
    value: Language.Japanese,
    label: 'Japanese',
  },
  {
    value: Language.Arabic,
    label: 'Arabic',
  },
  {
    value: Language.Hebrew,
    label: 'Hebrew',
  },
  {
    value: Language.Romanian,
    label: 'Romanian',
  },
  {
    value: Language.Greek,
    label: 'Greek',
  },
  {
    value: Language.Italian,
    label: 'Italian',
  },
  {
    value: Language.German,
    label: 'German',
  },
  {
    value: Language.Armenian,
    label: 'Armenian',
  },
  {
    value: Language.Tagalog,
    label: 'Tagalog',
  },
];

export const INDIVIDUAL_GENDER_LABELS: SelectMap[] = [
  {
    value: IndGender.Male,
    label: 'Male',
  },
  {
    value: IndGender.Female,
    label: 'Female',
  },
];

export const INDIVIDUAL_STATUS_LABELS: SelectMap[] = [
  {
    value: IndStatus.Active,
    label: 'Active Client',
  },
  {
    value: IndStatus.Inactive,
    label: 'Inactive Client',
  },
  {
    value: IndStatus.Prospect,
    label: 'Prospect',
  },
  {
    value: IndStatus.InactiveProspect,
    label: 'Inactive Prospect',
  },
  {
    value: IndStatus.Deceased,
    label: 'Deceased',
  },
];

export const PROFILE_LOG_PORTAL_TAB_LABELS: SelectMap[] = [
  {
    value: PROFILE_LOG_TAB.CALL_LOG,
    label: 'Call Log',
  },
  {
    value: PROFILE_LOG_TAB.SMS_LOG,
    label: 'SMS Log',
  },
  {
    value: PROFILE_LOG_TAB.OTHER_LOGS,
    label: 'Other Logs',
  },
];

export const INDIVIDUAL_POLICY_WRITTEN_AS_LABELS: SelectMap[] = [
  {
    value: INDIVIDUAL_POLICY_WRITTEN_AS.NEW_TO_MEDICARE,
    label: INDIVIDUAL_POLICY_WRITTEN_AS.NEW_TO_MEDICARE,
  },
  {
    value: INDIVIDUAL_POLICY_WRITTEN_AS.LIKE_PLAN_CHANGE,
    label: INDIVIDUAL_POLICY_WRITTEN_AS.LIKE_PLAN_CHANGE,
  },
  {
    value: INDIVIDUAL_POLICY_WRITTEN_AS.LIKE_PLAN_CHANGE_SAME_COMPANY,
    label: INDIVIDUAL_POLICY_WRITTEN_AS.LIKE_PLAN_CHANGE_SAME_COMPANY,
  },
  {
    value: INDIVIDUAL_POLICY_WRITTEN_AS.UNLIKE_PLAN_CHANGE,
    label: INDIVIDUAL_POLICY_WRITTEN_AS.UNLIKE_PLAN_CHANGE,
  },
  {
    value: INDIVIDUAL_POLICY_WRITTEN_AS.AOR_CHANGE,
    label: INDIVIDUAL_POLICY_WRITTEN_AS.AOR_CHANGE,
  },
  {
    value: INDIVIDUAL_POLICY_WRITTEN_AS.NA,
    label: INDIVIDUAL_POLICY_WRITTEN_AS.NA,
  },
];

export const PLAN_TYPE_LABELS: SelectMap[] = [
  {
    value: PLAN_TYPE_TYPE.ANC,
    label: PLAN_TYPE_TYPE.ANC,
  },
  {
    value: PLAN_TYPE_TYPE.ANNUITY,
    label: PLAN_TYPE_TYPE.ANNUITY,
  },
  {
    value: PLAN_TYPE_TYPE.IND,
    label: PLAN_TYPE_TYPE.IND,
  },
  {
    value: PLAN_TYPE_TYPE.LIFE,
    label: PLAN_TYPE_TYPE.LIFE,
  },
  {
    value: PLAN_TYPE_TYPE.LTC,
    label: PLAN_TYPE_TYPE.LTC,
  },
  {
    value: PLAN_TYPE_TYPE.MAPD,
    label: PLAN_TYPE_TYPE.MAPD,
  },
  {
    value: PLAN_TYPE_TYPE.PDP,
    label: PLAN_TYPE_TYPE.PDP,
  },
  {
    value: PLAN_TYPE_TYPE.SUP,
    label: PLAN_TYPE_TYPE.SUP,
  },
];

export const DIRECTMAILMANAGER_POSTCARD_SIZE_LABELS: SelectMap[] = [
  {
    value: DIRECTMAILMANAGER_POSTCARD_SIZE.FOURBYSIX,
    label: 'Postcard 4x6',
  },
  {
    value: DIRECTMAILMANAGER_POSTCARD_SIZE.SIXBYNINE,
    label: 'Postcard 6x9',
  },
];

export const THANKSIO_MAIL_TYPE_LABELS: SelectMap[] = [
  {
    value: THANKSIO_MAIL_TYPE.POSTCARD,
    label: 'Postcard',
  },
  {
    value: THANKSIO_MAIL_TYPE.NOTECARD,
    label: 'Notecard',
  },
  {
    value: THANKSIO_MAIL_TYPE.LETTER,
    label: 'Letter',
  },
  {
    value: THANKSIO_MAIL_TYPE.WINDOWLESSLETTER,
    label: 'Windowless Letter',
  },
  {
    value: THANKSIO_MAIL_TYPE.GITFCARD,
    label: 'Giftcard',
  },
];

export const INDIVIDUAL_POLICY_STATUS_TYPE_LABELS: SelectMap[] = [
  { value: INDIVIDUAL_POLICY_STATUS_TYPE.ACTIVE, label: INDIVIDUAL_POLICY_STATUS_TYPE.ACTIVE },
  {
    value: INDIVIDUAL_POLICY_STATUS_TYPE.CANCELLED,
    label: INDIVIDUAL_POLICY_STATUS_TYPE.CANCELLED,
  },
  { value: INDIVIDUAL_POLICY_STATUS_TYPE.DECLINED, label: INDIVIDUAL_POLICY_STATUS_TYPE.DECLINED },
  { value: INDIVIDUAL_POLICY_STATUS_TYPE.PENDING, label: INDIVIDUAL_POLICY_STATUS_TYPE.PENDING },
  { value: INDIVIDUAL_POLICY_STATUS_TYPE.REPLACED, label: INDIVIDUAL_POLICY_STATUS_TYPE.REPLACED },
];

export const THANKSIO_POSTCARD_SIZE_LABELS: SelectMap[] = [
  {
    value: THANKSIO_POSTCARD_SIZE.FOURBYSIX,
    label: THANKSIO_POSTCARD_SIZE.FOURBYSIX,
  },
  {
    value: THANKSIO_POSTCARD_SIZE.SIXBYNINE,
    label: THANKSIO_POSTCARD_SIZE.SIXBYNINE,
  },
];

export const USER_ACTIVITY_PRIORITY_TYPE_LABELS: SelectMap[] = [
  {
    value: USER_ACTIVITY_PRIORITY_TYPE.LOW,
    label: 'Low',
  },
  {
    value: USER_ACTIVITY_PRIORITY_TYPE.MEDIUM,
    label: 'Medium',
  },
  {
    value: USER_ACTIVITY_PRIORITY_TYPE.HIGH,
    label: 'High',
  },
];

export const AUTOMATION_TRIGGER_DATA_FIELD_TYPE_LABELS: SelectMap[] = [
  {
    value: AUTOMATION_TRIGGER_DATA_FIELD_TYPE.IND_STATUS,
    label: 'Ind: Status',
  },
  {
    value: AUTOMATION_TRIGGER_DATA_FIELD_TYPE.USER_FLAG,
    label: 'Ind: Flag',
  },
  {
    value: AUTOMATION_TRIGGER_DATA_FIELD_TYPE.USER_SOURCE,
    label: 'Ind: Source',
  },
  {
    value: AUTOMATION_TRIGGER_DATA_FIELD_TYPE.PLAN_TYPE,
    label: 'Policy: Type',
  },
  {
    value: AUTOMATION_TRIGGER_DATA_FIELD_TYPE.USER_LEAD_STATUS,
    label: 'Lead: Status',
  },
  {
    value: AUTOMATION_TRIGGER_DATA_FIELD_TYPE.IND_POLICY_STATUS,
    label: 'Policy: Status',
  },
  {
    value: AUTOMATION_TRIGGER_DATA_FIELD_TYPE.IND_POLICY_COMPANY,
    label: 'Policy: Company',
  },
  {
    value: AUTOMATION_TRIGGER_DATA_FIELD_TYPE.IND_POLICY_WRITTEN_AS,
    label: 'Ind: Policy: Written As',
  },
  {
    value: AUTOMATION_TRIGGER_DATA_FIELD_TYPE.IND_PREFERRED_LANGUAGE,
    label: 'Ind: Preferred Language',
  },
  {
    value: AUTOMATION_TRIGGER_DATA_FIELD_TYPE.IND_AGE,
    label: 'Ind: Age',
  },
  {
    value: AUTOMATION_TRIGGER_DATA_FIELD_TYPE.IND_BIRTHDAY_UPCOMING,
    label: 'Ind: Upcoming Birthday',
  },
  {
    value: AUTOMATION_TRIGGER_DATA_FIELD_TYPE.IND_GENDER,
    label: 'Ind: Gender',
  },
];

export const AUTOMATION_TRIGGER_RECIPE_LABELS: SelectMap[] = [
  {
    value: AUTOMATION_TRIGGER_COMBINATION.IND_STATUS_INSERT,
    label: 'Ind: New',
  },
  {
    value: AUTOMATION_TRIGGER_COMBINATION.IND_STATUS_UPDATE,
    label: 'Ind: Status - Change',
  },
  {
    value: AUTOMATION_TRIGGER_COMBINATION.IND_BIRTHDAY,
    label: 'Ind: Birthday',
  },
  {
    value: AUTOMATION_TRIGGER_COMBINATION.IND_BIRTHDAY_UPCOMING,
    label: 'Ind: Upcoming Birthday',
  },
  {
    value: AUTOMATION_TRIGGER_COMBINATION.USER_LEAD_INSERT,
    label: 'Lead: New',
  },
  {
    value: AUTOMATION_TRIGGER_COMBINATION.USER_LEAD_STATUS_UPDATE,
    label: 'Lead: Status - Change',
  },
  {
    value: AUTOMATION_TRIGGER_COMBINATION.IND_POLICY_STATUS_INSERT,
    label: 'Policy: Status - New',
  },
  {
    value: AUTOMATION_TRIGGER_COMBINATION.IND_POLICY_STATUS_UPDATE,
    label: 'Policy: Status -  Change',
  },
  {
    value: AUTOMATION_TRIGGER_COMBINATION.IND_POLICY_STATUS_UPSERT,
    label: 'Policy: Status - New or Change',
  },
  {
    value: AUTOMATION_TRIGGER_COMBINATION.IND_POLICY_PREMIUM_INSERT,
    label: 'Policy: Premium/ Accumulation Value - New',
  },
];

export const AUTOMATION_ACTION_TYPE_LABELS: SelectMap[] = [
  {
    value: AUTOMATION_ACTION_TYPE.SEND_EMAIL,
    label: 'Send - Email',
  },
  {
    value: AUTOMATION_ACTION_TYPE.SEND_SMS,
    label: 'Send - SMS',
  },
  {
    value: AUTOMATION_ACTION_TYPE.SEND_MAIL,
    label: 'Send - Mail',
  },
  {
    value: AUTOMATION_ACTION_TYPE.SEND_RINGLESS_VM,
    label: 'Send - Ringless Voicemail',
  },
  {
    value: AUTOMATION_ACTION_TYPE.CREATE_ACTIVITY,
    label: 'Activity - New',
  },
  {
    value: AUTOMATION_ACTION_TYPE.UPDATE_LEAD,
    label: 'Change - Lead status',
  },
  {
    value: AUTOMATION_ACTION_TYPE.SYNC_CONTACT,
    label: 'Sync - Add Contact',
  },
  {
    value: AUTOMATION_ACTION_TYPE.SYNC_REMOVE_CONTACT,
    label: 'Sync - Remove Contact',
  },
  {
    value: AUTOMATION_ACTION_TYPE.FLOW_UPSERT,
    label: 'Flow - add/move',
  },
];

export const AUTOMATION_ACTION_TYPE_ICONS: SelectMap[] = [
  {
    value: AUTOMATION_ACTION_TYPE.SEND_EMAIL,
    label: 'fa-at',
  },
  {
    value: AUTOMATION_ACTION_TYPE.SEND_SMS,
    label: 'fa-comment',
  },
  {
    value: AUTOMATION_ACTION_TYPE.SEND_MAIL,
    label: 'fa-mailbox',
  },
  {
    value: AUTOMATION_ACTION_TYPE.SEND_RINGLESS_VM,
    label: 'fa-phone',
  },
  {
    value: AUTOMATION_ACTION_TYPE.CREATE_ACTIVITY,
    label: 'fa-list',
  },
  {
    value: AUTOMATION_ACTION_TYPE.UPDATE_LEAD,
    label: 'fa-user-alt',
  },
  {
    value: AUTOMATION_ACTION_TYPE.SYNC_CONTACT,
    label: 'fa-sync',
  },
  {
    value: AUTOMATION_ACTION_TYPE.FLOW_UPSERT,
    label: 'fa-stream',
  },
];

export const USER_LETTER_TYPE_TYPE_LABELS: SelectMap[] = [
  {
    value: USER_LETTER_TYPE_TYPE.ALL,
    label: 'All',
  },
  {
    value: USER_LETTER_TYPE_TYPE.EMAIL,
    label: 'Email',
  },
  {
    value: USER_LETTER_TYPE_TYPE.LETTER,
    label: 'Letter',
  },
  {
    value: USER_LETTER_TYPE_TYPE.SMS,
    label: 'SMS',
  },
];
